<template>
  <div id="allnews" class="allnews">
    <div class="allnews_banner">
      <img
        src="//static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/allnews_phone_banner.ab59e7a5.png"
        alt=""
      />
    </div>
    <Tabs :tabs="tabs" :currentTab="currentTab" @onClick="handleClick" />
    <div class="news_inner" id="news_inner">
      <div class="newlist_container">
        <div class="newlist" v-for="item in currentNewsList" :key="item.list">
          <a :href="item.href" class="title" target="_blank">{{ item.title }}</a>
          <span class="newdate">{{ item.date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tabs from 'vue-tabs-with-active-line';
export default {
  name: 'news',
  props: {
    allnewsList: {
      type: Array,
      default: () => []
    },
    tabs: {
      type: Array,
      default: () => []
    },
    currentTab: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
    };
  },
  components: {
    Tabs
  },
  computed: {
    currentNewsList() {
      return this.allnewsList.find(item => item.date === this.currentTab)?.list || [];
    }
  },
  mounted() {
  },
  methods: {
    handleClick(val) {
      this.currentTab = val;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.allnews_banner {
  text-align: center;
  img {
    width: 100%;
    display: block;
  }
}
.news_inner {
  width: 100%;
  padding: rem(120) rem(72) rem(76);
  margin: 0 auto;
  box-sizing: border-box;
  .newlist {
    padding: rem(48) 0;
    border-bottom: rem(3) solid #fafafa;
    a {
      display: block;
      font-size: rem(48);
      color: #333;
    }
    .newdate {
      display: block;
      padding-top: rem(32);
      color: #999;
      line-height: rem(52);
      font-size: rem(42);
    }
  }
}

::v-deep {
  .tabs {
    display: flex;
    justify-content: space-between;
    padding: rem(42);
    background: #fbfbfb;
  } 
  .tabs__item {
    padding: 0;
    border: none;
    color: #666;
    font-size: rem(53);
    background: none;
    @include disable-tap-highlight;
  }
  .tabs__item_active {
    color: #333;
    position: relative;
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: rem(-42);
      left: 0;
      width: 100%;
      height: rem(6);
      background: #1680FC;
    }
  }
  .tabs__active-line {
    display: none;
  } 
}
</style>
